var map = {
	"./alastair-smith-135x135.jpg": 8631,
	"./bk-centralized-system.png": 7420,
	"./bk-consistent-visuals.png": 1152,
	"./bk-creative-flow.png": 3908,
	"./bk-fast-correct.png": 2175,
	"./bk-monthly-delivery.png": 2500,
	"./bk-zero-stress.png": 6652,
	"./family-fashion-shopify-campaign-banner.jpg": 8860,
	"./healthcare_social_media_ads.png": 9760,
	"./hero-bg-desktop.jpg": 7500,
	"./hero-bg-mobile.jpg": 3561,
	"./hero-bg-tablet.jpg": 8576,
	"./hero-stack.png": 3880,
	"./hero-stack.webp": 5964,
	"./industrial-services-car-magnet-sticker.jpg": 3224,
	"./industrial-services-editable-forms.jpg": 3124,
	"./industrial-services-flyer-design.jpg": 3092,
	"./industrial-services-service-stickers.jpg": 4428,
	"./industrial-services-social-media-ad-design-1.jpg": 6568,
	"./industrial-services-social-media-ad-design-2.jpg": 3108,
	"./industrial-services-work-uniforms.jpg": 6044,
	"./lifestyle-brand-custom-logo-design-and-brand-identity.jpg": 1264,
	"./retail-custom-logo-design-and-brand-identity.jpg": 3436,
	"resources/images/brandkeeper/alastair-smith-135x135.jpg": 8631,
	"resources/images/brandkeeper/bk-centralized-system.png": 7420,
	"resources/images/brandkeeper/bk-consistent-visuals.png": 1152,
	"resources/images/brandkeeper/bk-creative-flow.png": 3908,
	"resources/images/brandkeeper/bk-fast-correct.png": 2175,
	"resources/images/brandkeeper/bk-monthly-delivery.png": 2500,
	"resources/images/brandkeeper/bk-zero-stress.png": 6652,
	"resources/images/brandkeeper/family-fashion-shopify-campaign-banner.jpg": 8860,
	"resources/images/brandkeeper/healthcare_social_media_ads.png": 9760,
	"resources/images/brandkeeper/hero-bg-desktop.jpg": 7500,
	"resources/images/brandkeeper/hero-bg-mobile.jpg": 3561,
	"resources/images/brandkeeper/hero-bg-tablet.jpg": 8576,
	"resources/images/brandkeeper/hero-stack.png": 3880,
	"resources/images/brandkeeper/hero-stack.webp": 5964,
	"resources/images/brandkeeper/industrial-services-car-magnet-sticker.jpg": 3224,
	"resources/images/brandkeeper/industrial-services-editable-forms.jpg": 3124,
	"resources/images/brandkeeper/industrial-services-flyer-design.jpg": 3092,
	"resources/images/brandkeeper/industrial-services-service-stickers.jpg": 4428,
	"resources/images/brandkeeper/industrial-services-social-media-ad-design-1.jpg": 6568,
	"resources/images/brandkeeper/industrial-services-social-media-ad-design-2.jpg": 3108,
	"resources/images/brandkeeper/industrial-services-work-uniforms.jpg": 6044,
	"resources/images/brandkeeper/lifestyle-brand-custom-logo-design-and-brand-identity.jpg": 1264,
	"resources/images/brandkeeper/retail-custom-logo-design-and-brand-identity.jpg": 3436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2048;